export default __webpack_public_path__ + "static/cashflow_202_1996_5-e043849cf206c6d74b68bba5ec980c0c.jpeg";